import React from 'react';
import { Route, Switch } from "react-router-dom";
import AdminTransferList from "./admin-transfer-list/admin-transfer-list";

const AdminTransfers = () => {
  return (
    <Switch>
      <Route exact path="/transfers">
        <AdminTransferList />
      </Route>
    </Switch>
  )
}

export default AdminTransfers;
